module.exports = (parcelRequire.load("kxJwj")).then(() => parcelRequire('bSiXt'));